<template>
  <div class="enterprise-interaction">
    <van-swipe
      class="my-swipe"
      :autoplay="autoplay"
      :swipeTo="2"
      indicator-color="white"
    >
      <van-swipe-item v-for="(item, index) in information.videos" :key="index">
        <img v-if="item.fileType == 1" :src="item.ossUrl" />
        <video-player
          v-else
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions[index]"
        ></video-player>
        <!-- <video
          :id="'video' + index"
          width="200px"
          height="145px"
          controls
          class="video-play"
          x5-video-player-type="h5"
          @click="videoIndex($event)"
        >
          <source :src="item.ossUrl" type="video/mp4" />
          <source type="video/webm" :src="item.ossUrl" />
          <source type="video/ogg" :src="item.ossUrl" />

          浏览器不支持 video 标签，建议升级浏览器。
        </video> -->
      </van-swipe-item>
    </van-swipe>
    <div class="enterprise">
      <div class="enterprise-name">
        <img src="../../../assets/images/default-avatar.png" alt="" />
        <div class="command">
          <b>{{ userInfo.entName }}</b>
          <div>
            <span>{{ userInfo.creditCode }}</span>
            <span class="manufacturing">{{ userInfo.industryName }}</span>
          </div>
        </div>
      </div>
      <div
        class="enterprise-list"
        v-if="information.labelName && information.labelName.length"
      >
        <span v-for="(item, index) in information.labelName" :key="index">{{
          item
        }}</span>
      </div>
    </div>
    <div class="news" @click="newsList">
      <img src="@assets/imagess/news.png" alt="" />
      <van-notice-bar
        mode="link"
        color="#1989fa"
        background="#fff"
        :scrollable="false"
      >
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false"
          v-if="newList && newList.length > 0"
        >
          <van-swipe-item v-for="(item, index) in newList" :key="index">{{
            item
          }}</van-swipe-item>
        </van-swipe>
        <div v-else>暂无消息</div>
      </van-notice-bar>
    </div>

    <van-tabs
      v-model="active"
      title-active-color="#41a1ff"
      line-width="30"
      color="#41a1ff"
      @click="onChoice()"
      title-class="tabs-nav"
    >
      <van-tab title="企业主页">
        <home-page
          :corporate="information"
          ref="company"
          v-if="information.entData"
        ></home-page>
      </van-tab>
      <van-tab title="工商信息">
        <business-information v-if="active === 1"></business-information>
      </van-tab>
      <!-- <van-tab title="" disabled></van-tab> -->
    </van-tabs>
    <div class="big-img" v-if="bigImg" @click="bigImg = false">
      <img :src="bigPicture" alt="" />
    </div>
  </div>
</template>

<script>
import { getAddress } from '@api/lishui/live'
import homePage from './components/companyPages'
import businessInformation from './components/businessInformation'
import { getLocalStorage, getToken, getQueryString } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import {
  getEntDetail,
  getSMSReadReacordByPage
} from '@api/businessInformation/index'
export default {
  components: {
    homePage,
    businessInformation
  },
  data() {
    return {
      playerOptions: [],
      timer: null,
      active: 0,
      autoplay: 30000,
      information: {},
      bigImg: false,
      bigPicture: '',

      userInfo: {
        entName: '',
        creditCode: '',
        industryName: ''
      },
      newList: [],
      addressUrl: '',
      user: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  created() {
    if (getToken()) {
      this.getEntOpens()
      this.getSMSReadReacord()
    }
  },
  mounted() {},
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.user.creditCode,
        entName: this.user.entName,
        mobile: this.user.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    onChoice(e) {
      this.buriedPoint()
    },
    videoIndex(event) {
      console.log(event)
    },
    // 图片放大
    bigUrl(e) {
      this.bigImg = true
      this.bigPicture = e
    },
    loginTokens() {
      getAddress().then(res => {
        this.addressUrl = res.data.data
        let list = this.information.entData
        if (list) {
          this.playerOptions = []
          // 视频
          this.information.videos.map(value => {
            /* value.ossUrl =
              this.addressUrl +
              process.env.VUE_APP_REQUEST_PREFIX3 +
              '/api/file/download?ossUrl=' +
              value.ossUrl +
              '&fileName=' +
              value.fileName */
            // 视频
            let arrStr = {
              playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
              autoplay: false, // 如果true,浏览器准备好时开始回放。
              muted: false, // 默认情况下将会消除任何音频。
              loop: false, // 导致视频一结束就重新开始。
              preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
              language: 'zh-CN',
              aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
              fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
              sources: [
                {
                  type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                  src: value.ossUrl // url地址
                }
              ],
              poster: '', // 你的封面地址
              // width: document.documentElement.clientWidth, //播放器宽度
              notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
              controlBar: {
                timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                fullscreenToggle: true // 全屏按钮
              }
            }
            this.playerOptions.push(arrStr)
          })
        }
      })
    },
    getSMSReadReacord() {
      const params = {
        pageNum: 1,
        pageSize: 3
      }
      getSMSReadReacordByPage(params).then(res => {
        const { data } = res.data
        this.newList = data.data.results.map(value => {
          return value.content
        })
      })
    },
    newsList() {
      this.buriedPoint()
      this.$router.push({ name: 'newsList' })
    },
    getEntOpens() {
      getEntDetail().then(res => {
        this.information = res.data.data
        if (this.information.entData) {
          this.userInfo.entName = this.information.entData.entName
          this.userInfo.creditCode = this.information.entData.creditCode
          this.userInfo.industryName = this.information.entData.industryName
          this.loginTokens()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  height: 200px;
  text-align: center;
  img {
    width: 100%;
    height: 100%;
  }
}
.video-play {
  width: 100%;
  height: 100%;
  background-color: #000;
  margin-right: 20px;
}
.enterprise-interaction {
  height: 100%;
  background-color: #fff;

  .news {
    border-top: 8px solid #f7f7f7;
    position: relative;
    img {
      position: absolute;
      left: 10px;
      top: 10px;
      z-index: 1;
      width: 20px;
      height: 20px;
    }
  }
  .enterprise {
    padding: 15px 0 16px 20px;
    .enterprise-name {
      display: flex;
      font-size: 16px;
      // line-height: 26px;
      img {
        width: 50px;
        height: 50px;
        border-radius: 8px;
        margin-right: 20px;
      }
      span {
        color: #999;
        font-size: 14px;
        margin-right: 20px;
        vertical-align: middle;
      }
      .command {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .manufacturing {
        display: inline-block;
        width: 90px;
        overflow: hidden;
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap;
      }
    }
    .enterprise-list {
      margin-top: 20px;
      font-size: 14px;
      color: #41a1ff;
      span {
        display: inline-block;
        padding: 5px 8px;
        margin-right: 20px;
        background-color: rgba($color: #41a1ff, $alpha: 0.1);
      }
    }
  }
}
/deep/ .van-tabs__wrap {
  border-top: 8px solid rgba(247, 247, 247, 1);
  border-bottom: 1px solid rgba(226, 226, 226, 1);
}
/deep/.van-tab {
  font-size: 16px;
}
/deep/ .notice-swipe {
  height: 40px;
  line-height: 40px;
}
/deep/.van-notice-bar__wrap {
  margin-left: 23px;
}
</style>
